import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '漫画分类', href: '#index' },
  { label: '热门排行', href: '#ranking' },
  { label: '平台特色', href: '#features' },
  { label: 'APP下载', href: '#app' },
  { label: '联系我们', href: '#contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70 py-3'
          : 'bg-transparent py-4'
      }`}
    >
      <nav className="w-full px-4 md:px-6 flex items-center justify-between max-w-[1400px] mx-auto" aria-label="主导航">
        <a
          href="#hero"
          className={`flex items-center gap-2 whitespace-nowrap ${
            scrolled ? 'text-primary-600' : 'text-white'
          }`}
        >
          <span className="text-xl md:text-2xl font-heading font-bold tracking-wide">香香漫画</span>
        </a>

        <ul className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors duration-200 whitespace-nowrap ${
                  scrolled
                    ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                    : 'text-white/90 hover:text-white hover:bg-white/10'
                }`}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-3">
          <button
            type="button"
            className={`w-9 h-9 flex items-center justify-center rounded-lg transition-colors duration-200 cursor-pointer ${
              scrolled
                ? 'text-foreground-600 hover:text-primary-600 hover:bg-primary-50'
                : 'text-white/90 hover:text-white hover:bg-white/10'
            }`}
            aria-label="搜索"
          >
            <i className="ri-search-line text-lg"></i>
          </button>

          <button
            type="button"
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg transition-colors duration-200 cursor-pointer text-white/90 hover:text-white hover:bg-white/10"
            aria-label="菜单"
          >
            <i className="ri-menu-line text-lg"></i>
          </button>
        </div>
      </nav>
    </header>
  );
}